import axios from 'axios';
import parser from 'html-react-parser';
import { Base64 } from 'js-base64';
import React, { useEffect, useState, useRef } from 'react';
import {
  BrowserView,
  MobileView
} from "react-device-detect";
import { Helmet } from "react-helmet";
import { AiOutlineWhatsApp } from 'react-icons/ai';
import { FaDownload, FaFacebookF, FaSms, FaTwitter } from 'react-icons/fa';
import { FiInstagram, FiMail } from 'react-icons/fi';
import { IoLogoLinkedin } from 'react-icons/io5';
import { Link, useHistory, useParams } from 'react-router-dom';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton
} from "react-share";
import logo from '../../../../assets/images/logo/Haylo-for-white-background.png';
import logoThree from '../../../../assets/images/logo/Haylo-logo-white.png';
import { LoadingSpinner } from '../../../../components/Loader/Loader';
import { baseURLPublic, downloadUrl, URL_S3 } from '../../../../config/BaseUrl';
import EmailModal from '../../components/EmailModal';
import SMSModal from '../../components/SMSModal';
import '../style/microsite-one.css';
import '../style/style.css';
import PatronPage from '../../../SocialGalleryV2/PatronPage';

function MicrositeOneView() {

  const history = useHistory();
  const { id } = useParams()
  const viewItemId = isNaN(id) === false ? id : Base64.atob(id);

  const [loading, setLoading] = useState(false)
  const [previewItem, setPreviewItem] = useState("")
  const [socialShare, setSocialShare] = useState("")
  const [socialShareCount, setSocialShareCount] = useState("")
  const [shareTemplate, setShareTemplate] = useState(null)
  const [contents, setContents] = useState(null)
  const [customMedia, setCustomMedia] = useState(null)
  const [loadError, setLoadError] = useState('')
  const fetchSequence = useRef(0)
  const eventId = previewItem && previewItem.event_id

  //Fetch image video gif
  const fetchPreviewItem = async () => {
    const request = ++fetchSequence.current
    setLoading(true)
    setLoadError('')
    await baseURLPublic.get(`social-gallery-share-preview/${viewItemId}`)
      .then((res) => {
        if (request !== fetchSequence.current) return
        setPreviewItem(res.data.share_gallery_preview)
        setCustomMedia(res.data.social_gallery_v2 || null)
        if (res.data.social_gallery_v2) {
          setLoading(false)
          return
        }
        let eventIds = res.data.share_gallery_preview.event_id
        return baseURLPublic.get(`social-gallery-share-item/${eventIds}`)
          .then((res) => {
            if (request !== fetchSequence.current) return
            let shareItem = res.data && res.data;
            let templateName = shareItem.share_gallery && shareItem.share_gallery.micro_site_gallery.template_name;
            setSocialShare(res.data && res.data.share_gallery)
            if (shareItem && shareItem.contents.length > 0) {
              setContents(shareItem && shareItem.contents)
              console.log("shareItem", shareItem && shareItem.contents);
            }
            if (templateName !== null) {
              setShareTemplate(templateName)
            } else {
              setShareTemplate("one")
            }
            setLoading(false)
          })
      }).catch(() => {
        if (request !== fetchSequence.current) return
        setCustomMedia(null)
        setLoadError('We could not load this media. Please try again.')
        setLoading(false)
      })
  }



  const downloadFile = () => {
    setSocialShareCount("download")
    axios({
      url: `/logo192.png`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      responseType: 'blob'
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = link
        link.setAttribute('download', 'image.jpg')
        document.body.appendChild(link)
        link.click()
      })
  }

  const downloadImage = (countType) => {

    window.open(`${downloadUrl}social-gallery-download/${viewItemId}`)
  }


  //Fetch social gallery icon count
  const storeShareCount = async () => {
    if (!socialShareCount || !eventId || customMedia) return;
    const data = {
      event_id: eventId,
      media_id: previewItem.id,
      sharing_platform: socialShareCount ? socialShareCount : "",
    }
    await baseURLPublic.post("share-gallery-count", data)
  }


  useEffect(() => {
    fetchPreviewItem()
    storeShareCount()
    return () => { fetchSequence.current += 1 }
  }, [socialShareCount, viewItemId])


  const emailSendInfo = {
    event_id: eventId,
    media_id: previewItem.id
  }


  // ====================Social Share ======================

  // facebook
  const shareUrl = window.location.href
  // ====================Social Share ======================

  const DesktopViewSocial = () => {

    return (<>
      <Helmet>
        {/* <meta property="og:image" content={`${URL_S3 + 'event_gallery/photo/' + previewItem.event_photo}`} />
          <meta name="twitter:image" content={`${URL_S3 + 'event_gallery/photo/' + previewItem.event_photo}`} />
          <meta property="og:title" content="__OG_TITLE__" />
          <meta property="og:description" content="__OG_DESCRIPTION__" />
          <meta property="og:url" content={shareUrl} />
          <meta property="og:image" content={`${URL_S3 + 'event_gallery/photo/' + previewItem.event_photo}`} /> */}

        <title>The Haylo</title>
        <meta name="title" content="The Haylo" />
        <meta name="description" content="This is haylo gallery image" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://memberdev.thehaylo.com.au/social/gallery/view/MTAz" />
        <meta property="og:title" content="The Haylo" />
        <meta property="og:description" content="This is haylo gallery image" />
        <meta property="og:image" content={`${'https://memberdev.thehaylo.com.au' + logo}`} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://memberdev.thehaylo.com.au/social/gallery/view/MTAz" />
        <meta property="twitter:title" content="The Haylo" />
        <meta property="twitter:description" content="This is haylo gallery image" />
        <meta property="twitter:image" content={`${'https://memberdev.thehaylo.com.au' + logo}`} />
      </Helmet>
      {socialShare && socialShare.email === 1 && (
        <li>
          <Link to="#" data-toggle="modal" data-target="#socialShareEmail" style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><FiMail size={20} /></Link>
        </li>
      )}

      {socialShare && socialShare.sms === 1 && (
        <li>
          <Link to="#" data-toggle="modal" data-target="#socialShareSMS" style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><FaSms size={20} /></Link>
        </li>
      )}

      {socialShare && socialShare.facebook === 1 && (
        <li>
          <FacebookShareButton
            url={shareUrl}
            // quote={"Hey Share this article"}
            // hashtag="#React"
            onClick={e => setSocialShareCount("facebook")}
          >
            <Link to="#" style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><FaFacebookF size={20} /></Link>
          </FacebookShareButton>
        </li>
      )}

      {socialShare && socialShare.twitter === 1 && (
        <li>
          <TwitterShareButton url={shareUrl} onClick={e => setSocialShareCount("twitter")} >
            <Link to="#" style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><FaTwitter size={20} /></Link>
          </TwitterShareButton>
        </li>
      )}

      {socialShare && socialShare.linked_in === 1 && (
        <li>
          <LinkedinShareButton url={shareUrl} onClick={e => setSocialShareCount("linkedin")} >
            <Link to="#" style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><IoLogoLinkedin size={20} /></Link>
          </LinkedinShareButton>
        </li>
      )}

      {/* {socialShare && socialShare.instagram === 1 && (
          <li>
            <Link to="#" onClick={downloadImage.bind(this, "instagram")} style={{background: contents ? contents.SocialMenuStyle: '#CEA252'}}><FiInstagram size={20} /></Link>
          </li>
        )} */}

      {socialShare && socialShare.download === 1 && (
        <li>
          <Link to="#" onClick={downloadImage.bind(this, "download")} style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><FaDownload size={20} /></Link>
        </li>
      )}

    </>)
  }

  const MobileViewSocial = () => {
    let shareUrlMobile = window.location.href

    function telegramForwardButton($url, $text = '') {
      const share_url = 'https://t.me/share/url?url='.rawurlencode($url) + '&text='.rawurlencode($text);
      return <a href={share_url}>Share</a>;
    }

    return (<>
      {socialShare && socialShare.email === 1 && (
        <li>
          <Link to="#" data-toggle="modal" data-target="#socialShareEmail" style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><FiMail size={20} /></Link>
        </li>
      )}

      {socialShare && socialShare.sms === 1 && (
        <li>
          <Link to="#" data-toggle="modal" data-target="#socialShareSMS" style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><FaSms size={20} /></Link>
        </li>
      )}

      {socialShare && socialShare.facebook === 1 && (
        <li>
          {/* <FacebookShareButton 
          url={shareUrlMobile}
          quote={"Hey Share this article"}
          hashtag="#React"
          onClick={e => setSocialShareCount("facebook")}
        > 
        <FacebookIcon />
        </FacebookShareButton> */}
          {/* <a href={`fb://sharer`}  style={{background: contents ? contents.SocialMenuStyle: '#CEA252'}}><FaFacebookF size={20} /></a> */}
          <a href={`fb://faceweb/f?href=https://m.facebook.com/sharer.php?u=${shareUrlMobile}`} style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><FaFacebookF size={20} /></a>
          {/* <a href={`fb://faceweb/f?href=https://m.facebook.com/sharer.php?u=${shareUrlMobile}`}  style={{background: contents ? contents.SocialMenuStyle: '#CEA252'}}><FaFacebookF size={20} /></a> */}
          {/* <a href={`fb://facewebmodal/f?href=${shareUrlMobile}`}  style={{background: contents ? contents.SocialMenuStyle: '#CEA252'}}><FaFacebookF size={20} /></a> */}
          {/*
        {/* fb://share?href=${shareUrl} */}
        </li>
      )}

      {socialShare && socialShare.twitter === 1 && (
        <li>
          <TwitterShareButton
            url={shareUrlMobile}
            onClick={e => setSocialShareCount("twitter")} >
            <Link to="#" style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><FaTwitter size={20} /></Link>
          </TwitterShareButton>
        </li>
      )}

      {socialShare && socialShare.linked_in === 1 && (
        <li>
          <LinkedinShareButton url={shareUrlMobile} onClick={e => setSocialShareCount("linkedin")} >
            <Link to="#" style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><IoLogoLinkedin size={20} /></Link>
          </LinkedinShareButton>
        </li>
      )}

      {/* {socialShare && socialShare.instagram === 1 && (
      <li>
        <Link to="#" onClick={downloadImage.bind(this, "instagram")} style={{background: contents ? contents.SocialMenuStyle: '#CEA252'}}><FiInstagram size={20} /></Link>
      </li>
    )} */}

      {/* new */}

      {socialShare && socialShare.whats_app === 1 && (
        <li>
          <a href={`whatsapp://send?text=${shareUrlMobile}`} style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><AiOutlineWhatsApp size={20} /></a>
        </li>
      )}

      {/* {socialShare && socialShare.snapchat === 1 && (
      <li>
        <a href="https://www.snapchat.com/add/@"  style={{background: contents ? contents.SocialMenuStyle: '#CEA252'}}><FaSnapchat size={20} /></a>
      </li>
    )} 
    {socialShare && socialShare.telegram === 1 && (
      <li>
        <a href={"https://t.me/share/url?url={url}&text={text}"}  style={{background: contents ? contents.SocialMenuStyle: '#CEA252'}}><FaTelegram size={20} /></a> 
        <a href={`tg://msg_url?url=${shareUrlMobile}&msg=${"Welcome to Haylo"}`}  style={{background: contents ? contents.SocialMenuStyle: '#CEA252'}}><FaTelegram size={20} /></a>
      </li>
    )}
    {socialShare && socialShare.tiktok === 1 && (
      <li>
        <a href="https://tiktok.com/@"  style={{background: contents ? contents.SocialMenuStyle: '#CEA252'}}><SiTiktok size={20} /></a>
      </li>
    )}  */}

      {/* {socialShare && socialShare.signal === 1 && (
      <li>
        <a href="signl://msg?text=Hi&to=+1555999"><SiSignal size={20} /></a>
      </li>
    )} */}

      {/* new end */}
      {socialShare && socialShare.download === 1 && (
        <li>
          <Link to="#" onClick={downloadImage.bind(this, "download")} style={{ background: contents ? contents.SocialMenuStyle : '#CEA252' }}><FaDownload size={20} /></Link>
        </li>
      )}

    </>)
  }


  if (loadError) return <main className="sg-public-state"><p role="alert">{loadError}</p><button type="button" onClick={fetchPreviewItem}>Try again</button></main>;
  if (customMedia && !loading) return <><Helmet><meta name="referrer" content="no-referrer" /></Helmet><PatronPage data={customMedia} /></>;

  return (<>
    {loading ?
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100vh' }}>
        <LoadingSpinner />
        <h6 className="mt-2">Please wait...</h6>
      </div>
      : <>
        {shareTemplate === 'one' && (
          <div className="microsite-template">
            <div className="microsite-template-header-one">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="py-4 text-center template-one-header-content">
                      <img src={contents ? contents.logo : logo} className="img-fluid" alt="logo" style={{ width: "250px" }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-body my-5">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <div className="gallery-item-view text-center">
                      {!loading ?
                        <div className="gallery-image text-center">
                          {previewItem.media_type === 'photo' ?
                              (<img src={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} alt="random-photos" className="img-fluid img-thumbnail h-100" />) :
                              previewItem.media_type === 'video' ?
                                (<video width={"100%"} height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} controls>
                                  <source src={URL_S3 + 'event_gallery/video/' + previewItem.event_video} type="video/mp4" />
                                </video>)
                                :
                                previewItem.media_type === 'gif' ?
                                  (<video width={"100%"} height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} controls>
                                    <source src={URL_S3 + 'event_gallery/gif/' + previewItem.event_gif} type="video/mp4" />
                                  </video>) :
                                  previewItem.media_type === 'burst_gif' ?
                                    (<video width={"100%"} height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} controls>
                                      <source src={URL_S3 + 'event_gallery/burstgif/' + previewItem.event_gif} type="video/mp4" />
                                    </video>) :
                                    previewItem.media_type === 'boomerang' ?
                                      (<video width={"100%"} height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} controls>
                                        <source src={URL_S3 + 'event_gallery/video/' + previewItem.event_video} type="video/mp4" />
                                      </video>)
                                      : ''
                          }
                        </div>
                        : (<LoadingSpinner />)}


                      <p className="tag-line py-4">
                        {
                          contents ? parser(contents.contentBodyText) : "Share now with your family and friends"
                        }
                      </p>

                      <ul className="share-option">

                        {!loading ? (<>

                          <BrowserView>
                            <DesktopViewSocial />
                          </BrowserView>

                          <MobileView>
                            <MobileViewSocial />
                          </MobileView>
                        </>)
                          : (
                            <LoadingSpinner />
                          )}
                      </ul>

                      <Link to={{ pathname: `/social/gallery/${Base64.btoa(eventId)}` }} className="back-to-gallery">
                        {
                          contents ? parser(contents.buttonText) : 'Gallery'
                        }
                      </Link>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-microsite-one">
              <div className="container">
                <div className="row justify-content-center">
                  {
                    contents ?
                      <p className="text-center footer-name mb-0 py-4">{parser(contents.footerText)}</p>
                      :
                      <p className="text-center footer-name mb-0 py-4">Brought you by <Link to="#" style={{ color: "#fff" }}>The Haylo</Link></p>
                  }
                </div>
              </div>
            </div>
            <EmailModal sendEmail={emailSendInfo} />
            <SMSModal sendSMS={emailSendInfo} />
          </div>

        )}

        {shareTemplate === 'two' && (
          <div className="microsite-template">
            <div className="microsite-template-header">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="py-4 text-center template-one-header-content">
                      <img src={contents ? contents.logo : logo} className="img-fluid" alt="logo" style={{ width: "250px" }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-body my-5">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <div className="gallery-item-view text-center">
                      {!loading ?
                        <div className="gallery-image text-center">
                          {previewItem.media_type === 'photo' ?
                              (<img src={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} alt="random-photos" className="img-fluid img-thumbnail h-100" />) :
                              previewItem.media_type === 'video' ?
                                (<video width={"100%"} height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} controls>
                                  <source src={URL_S3 + 'event_gallery/video/' + previewItem.event_video} type="video/mp4" />
                                </video>)
                                :
                                previewItem.media_type === 'gif' ?
                                  (<video width={"100%"} height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} controls>
                                    <source src={URL_S3 + 'event_gallery/gif/' + previewItem.event_gif} type="video/mp4" />
                                  </video>) :
                                  previewItem.media_type === 'burst_gif' ?
                                    (<video width={"100%"} height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} controls>
                                      <source src={URL_S3 + 'event_gallery/burstgif/' + previewItem.event_gif} type="video/mp4" />
                                    </video>) :
                                    previewItem.media_type === 'boomerang' ?
                                      (<video width={"100%"} height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} controls>
                                        <source src={URL_S3 + 'event_gallery/video/' + previewItem.event_video} type="video/mp4" />
                                      </video>)
                                      : ''
                          }
                        </div>
                        : (<LoadingSpinner />)}


                      <p className="tag-line py-4">
                        {
                          contents ? parser(contents.contentBodyText) : "Share now with your family and friends"
                        }
                      </p>

                      <ul className="share-option">

                        {!loading ? (<>

                          <BrowserView>
                            <DesktopViewSocial />
                          </BrowserView>

                          <MobileView>
                            <MobileViewSocial />
                          </MobileView>

                        </>)
                          : (
                            <LoadingSpinner />
                          )}
                      </ul>

                      <Link to={{ pathname: `/social/gallery/${Base64.btoa(eventId)}` }} className="back-to-gallery">
                        {
                          contents ? parser(contents.buttonText) : 'Gallery'
                        }
                      </Link>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-microsite-one">
              <div className="container">
                <div className="row justify-content-center">
                  {
                    contents ?
                      <p className="text-center footer-name mb-0 py-4">{parser(contents.footerText)}</p>
                      :
                      <p className="text-center footer-name mb-0 py-4">Brought you by <Link to="#" style={{ color: "#fff" }}>The Haylo</Link></p>
                  }
                </div>
              </div>
            </div>
            <EmailModal sendEmail={emailSendInfo} />
            <SMSModal sendSMS={emailSendInfo} />
          </div>

        )}

        {shareTemplate === 'three' && (
          <div className="Customer-microsite-default">

            <div className="header default-header">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="header-image text-center py-4">
                      <img src={contents ? contents.logo : logoThree} className="img-fluid" alt="logo" style={{ width: "250px" }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-body mt-5">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <div className="gallery-item-view text-center">
                      {!loading ?
                        <div className="gallery-image text-center">
                          {
                            previewItem.media_type === 'photo' ?
                              (<img src={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} alt="random-photos" className="img-fluid img-thumbnail h-100" />) :
                              previewItem.media_type === 'video' ?
                                (<video width={"100%"} height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} controls>
                                  <source src={URL_S3 + 'event_gallery/video/' + previewItem.event_video} type="video/mp4" />
                                </video>)
                                :
                                previewItem.media_type === 'gif' ?
                                  (<video width={"100%"} height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} controls>
                                    <source src={URL_S3 + 'event_gallery/gif/' + previewItem.event_gif} type="video/mp4" />
                                  </video>) :
                                  previewItem.media_type === 'burst_gif' ?
                                    (<video width={"100%"} height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} controls>
                                      <source src={URL_S3 + 'event_gallery/burstgif/' + previewItem.event_gif} type="video/mp4" />
                                    </video>) :
                                    previewItem.media_type === 'boomerang' ?
                                      (<video width={"100%"} height={"100%"} className="pr-2 pr-md-0" poster={URL_S3 + 'event_gallery/photo/' + previewItem.event_photo} controls>
                                        <source src={URL_S3 + 'event_gallery/video/' + previewItem.event_video} type="video/mp4" />
                                      </video>)
                                      : ''
                          }
                        </div>
                        : (<LoadingSpinner />)}

                      <p className="tag-line py-4">
                        {
                          contents ? parser(contents.contentBodyText) : "Share now with your family and friends"
                        }
                      </p>

                      <ul className="share-option">

                        {!loading ? (<>

                          <BrowserView>
                            <DesktopViewSocial />
                          </BrowserView>

                          <MobileView>
                            <MobileViewSocial />
                          </MobileView>

                        </>)
                          : (
                            <LoadingSpinner />
                          )}
                      </ul>

                      <Link to={{ pathname: `/social/gallery/${Base64.btoa(eventId)}` }} className="back-to-gallery">
                        {
                          contents ? parser(contents.buttonText) : 'Gallery'
                        }
                      </Link>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="micro-site-footer">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    {
                      contents ?
                        <p className="text-center footer-name mb-0 py-4">{parser(contents.footerText)}</p>
                        :
                        <p className="text-center footer-name mb-0 py-4">Brought you by <Link to="#" style={{ color: "#fff" }}>The Haylo</Link></p>
                    }
                  </div>
                </div>
              </div>
            </div>

            <EmailModal sendEmail={emailSendInfo} />
            <SMSModal sendSMS={emailSendInfo} />
          </div>
        )}

      </>}
  </>)
}

export default MicrositeOneView
